import React, { useState } from "react";

import { TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  ModalDefaultError,
  ModalDeleteConfirm,
  TableAction,
  TableWrapper,
  TableCellDefault,
  IconButtonDatatable,
} from "App/Component/ui";

import { useDatatables, useFetch } from "App/hooks";
import {
  ModalForm,
  headCells,
  deleteMovieProfilingById,
  RESET_STATE_MOVIE_PROFILING,
  urlGet,
} from "./helpers";
import { TYPE_INSTANCE2 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
} from "App/utils/helpers";
import { SearchIcon } from "App/Assets";
import ModalDetailMovieProfiling from "./ModalDetailMovieProfiling";

export default function Bank() {
  const [showModal, setShowModal] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);

  const [showModalDefaultError, setShowModalDefaultError] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [rows, setRows] = useFetch(TYPE_INSTANCE2, urlGet);

  const [formData, setFormData] = useState(RESET_STATE_MOVIE_PROFILING);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  function clickAdd() {
    setFormData(RESET_STATE_MOVIE_PROFILING);
    setShowModal(!showModal);
  }

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      name: row?.name,
      remark: row?.remark,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function setNewData() {
    const newData = await fetchData(TYPE_INSTANCE2, urlGet);
    setRows(newData);
  }

  const deleteList = async () => {
    const res = await deleteMovieProfilingById(formData.id);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }
    setShowModalDeleteConfirm(false);
  };

  return (
    <>
      {showModal && (
        <ModalForm
          setNewData={setNewData}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDetail && (
        <ModalDetailMovieProfiling
          setNewData={setNewData}
          setShowModal={() => setShowModalDetail(false)}
          name={formData.name}
          id={formData.id}
        />
      )}

      {showModalDefaultError && (
        <ModalDefaultError
          setShowModalDefaultError={() => setShowModalDefaultError(true)}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={deleteList}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <TableWrapper
        title="Daftar Profiling"
        setQ={setQ}
        withExportButton={false}
        clickAddButton={() => clickAdd()}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>

                <TableCell component="th" scope="row" padding="none">
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    clickUpdate={() => clickUpdate(row)}
                  >
                    <IconButtonDatatable
                      onClick={() => {
                        setFormData({
                          id : row?.id,
                          name: row?.name,
                        });
                        setShowModalDetail(!showModalDetail);
                      }}
                    >
                      <SearchIcon
                        style={{
                          marginTop: "5px",
                        }}
                        width={"18"}
                        height={"18"}
                        fill={"#fff"}
                      />
                    </IconButtonDatatable>
                  </TableAction>
                </TableCell>

                <TableCell align="left">{row?.name}</TableCell>
                <TableCell align="left">{row?.remark}</TableCell>
                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
      </TableWrapper>
    </>
  );
}
